import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { AxiosError } from 'axios';

import fetchQuilttSessionToken from './useQuilttSessionToken.request';
import { QuilttSessionTokenResponse } from './useQuilttSessionToken.interface';

export const QUILTT_SESSION_TOKEN_QUERY_KEY = ['quilttSessionToken'];

export default function useQuilttSessionToken(options?: UseQueryOptions<QuilttSessionTokenResponse, AxiosError>) {
    return useQuery<QuilttSessionTokenResponse, AxiosError>({
        queryKey: QUILTT_SESSION_TOKEN_QUERY_KEY,
        queryFn: fetchQuilttSessionToken,
        refetchOnWindowFocus: false,
        staleTime: 4 * 60 * 60 * 1000, // 4 hours, tokens last for 2 days
        ...options,
    });
}
